export default function RevenueLoader() {
    return (
        <>
            <div className=" p-3 p-lg-4 shadow rounded card ">
                <div className="row">
                    <div className="mb-2 placeholder-glow ">
                        {/* Top Section */}
                        <div className='placeholder placeholder-xs col-2 mb-2'> </div><br />
                        <div className='placeholder placeholder-lg col-4 mb-2'> </div><br />
                        <div className='placeholder placeholder-xs col-3 mb-2'> </div>
                    </div>
                </div>

                <hr />

                {/* Bottom Section */}
                <div className="d-flex justify-content-between mt-2 mb-3 me-5">
                    {/* Success */}
                    <div className="d-flex align-items-center">
                        <div className="me-2 d-flex align-items-center justify-content-center placeholder"
                            style={{ width: '30px', height: '30px', borderRadius: '50%' }}>
                        </div>
                        <div className="row  ms-1">
                            <div className="placeholder placeholder-xs col-1"></div>
                            <div className='placeholder placeholder-xs col-12 mt-2'></div>
                        </div>
                    </div>

                    {/* Failure */}
                    <div className="d-flex align-items-center">
                        <div className="me-2 d-flex align-items-center justify-content-center placeholder"
                            style={{ width: '30px', height: '30px', borderRadius: '50%' }}>
                        </div>
                        <div className="row  ms-1">
                            <div className="placeholder placeholder-xs col-1"></div>
                            <div className='placeholder placeholder-xs col-12 mt-2'></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}